export const CHEAP = 'bid-options/cheap';
export const SIMPLE = 'bid-options/simple';
export const JUMP = 'bid-options/jump';
export const GAME = 'bid-options/game';
